import React from 'react'
import PropTypes from 'prop-types'
import { IoMdOpen } from 'react-icons/io'
import Component from '../../common/Component'
import Modal from '../../common/Modal'

export default class ResultsModal extends Component {
  static propTypes = {
    failures: PropTypes.array.isRequired
  }

  constructor(props) {
    super(props)
    this.state = { isOpen: false }
  }

  handleOpen = () => this.setState({ isOpen: true })

  handleClose = () => this.setState({ isOpen: false })

  formatHeader(key) {
    return key.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())
  }

  render() {
    const { failures } = this.props
    const headers = failures.length > 0 ? Object.keys(failures[0]) : []

    return (
      <span>
        <button
          type="button"
          className="modal-button"
          aria-label="View failure details"
          onClick={this.handleOpen}
        >
          <IoMdOpen size={20} className="error" />
        </button>
        {this.state.isOpen && (
          <Modal className="result-failures-modal" handleClose={this.handleClose}>
            <h3>Failure Details</h3>
            <table className="pure-table pure-table-bordered">
              <thead>
                <tr>
                  {headers.map((key) => <th key={key}>{this.formatHeader(key)}</th>)}
                </tr>
              </thead>
              <tbody>
                {failures.map((failure, idx) => (
                  <tr key={idx}>
                    {headers.map((key) => (
                      <td key={key}>{failure[key] != null ? String(failure[key]) : '\u2014'}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </Modal>
        )}
      </span>
    )
  }
}
